module.exports = __webpack_public_path__ + "static/media/Q2_ans.e990ff4e.png";